import { render, staticRenderFns } from "./FarmacieListComponent.vue?vue&type=template&id=dfc4796a"
import script from "./FarmacieListComponent.vue?vue&type=script&lang=js"
export * from "./FarmacieListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports